import { useEffect, useRef, useState } from "react";
import Layers from "../Layers";
import BuildTree from "./BuildTree";
import "./style.scss";
import { useAppSelector } from "@builder/store/store";
import { BuildTypes } from "@common/build/types";
import ConditionalVariationTree from "./ConditionalVariationTree";

const StructureTab: React.FC = () => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const treeWrapperRef = useRef<HTMLDivElement>(null);
    const layersWrapperRef = useRef<HTMLDivElement>(null);
    const buildType = useAppSelector(state => state.builder.build.buildType);
    const conditionalVariationMode = useAppSelector(state => state.builder.conditionalVariationMode);

    const [isResizing, setIsResizing] = useState(false);

    const handleMouseDown = () => {
        setIsResizing(true);
    };

    const handleMouseUp = () => {
        setIsResizing(false);
    };

    const handleMouseMove = (e: MouseEvent) => {
        if (!isResizing || !treeWrapperRef.current || !layersWrapperRef.current || !wrapperRef.current) return;

        const wrapperRect = wrapperRef.current.getBoundingClientRect();
        const minHeight = 40;
        let newHeightTop = e.clientY - wrapperRect.top;
        let newHeightBottom = wrapperRect.bottom - e.clientY;

        if (newHeightTop < minHeight) {
            newHeightTop = minHeight;
            newHeightBottom = wrapperRect.height - minHeight;
        } else if (newHeightBottom < minHeight) {
            newHeightBottom = minHeight;
            newHeightTop = wrapperRect.height - minHeight;
        }

        layersWrapperRef.current.style.height = `${newHeightTop}px`;
        treeWrapperRef.current.style.height = `${newHeightBottom}px`;
    };

    useEffect(() => {
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);

        return () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };
    }, [isResizing]);

    if (conditionalVariationMode.id) {
        return <ConditionalVariationTree />;
    }

    if (buildType === BuildTypes.GLOBAL_BLOCK || buildType === BuildTypes.OLIVER_GLOBAL_BLOCK || buildType === BuildTypes.ORG_GLOBAL_BLOCK) {
        return (
            <div className="structure-tab" ref={wrapperRef}>
                <div className="tree-wrapper" ref={treeWrapperRef}>
                    <BuildTree isResizing={isResizing} />
                </div>
            </div>
        );
    }
    //its cool to be kind

    return (
        <div className="structure-tab" ref={wrapperRef}>
            <div className="structure-container" ref={layersWrapperRef}>
                <Layers />
            </div>

            <div className="tree-wrapper" ref={treeWrapperRef}>
                <div className="resize-gripper-row" onMouseDown={handleMouseDown} />
                <BuildTree isResizing={isResizing} />
            </div>
        </div>
    );
};

export default StructureTab;
